import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
var OneKeyMap = /*#__PURE__*/_createClass(function OneKeyMap() {
  _classCallCheck(this, OneKeyMap);
  this.set = void 0;
  this.get = void 0;
  var key, val;
  this.get = function (k) {
    return k === key ? val : void 0;
  };
  this.set = function (k, v) {
    key = k;
    val = v;
  };
});
export default OneKeyMap;